<template lang="pug">
  .root.max-w-lg.mx-auto
    div(v-if="showFixed")
      header-component(:handleGoBack="handleGoBack" :showFixed="showFixed").transition.HeaderDk
    div(v-else)
      header-component(:handleGoBack="handleGoBack" :showFixed="showFixed").transition.HeaderDk
    main.Main(:class="(footerMode ? 'content' : '') + smallFooter + (!showFixed ? ' addMarginTopSpecial ' : ' addMarginTop ')")
      .pb-20
        div(v-if="agendamientoMode" :class="eps.id && 'px-5'").mx-5
          div(:class="!eps.id ? 'mt-14' : 'mt-5'").transition.max-w-sm.mx-auto.bg-white.rounded-xl.shadow-bx-small-sm.p-5.text-center.pt-3
            h2.text-primary.text-xl.m-0.font-semibold Agendamiento de citas
            transition(name="fadeIn")
              div(v-if="!eps.id")
                p.mt-1.text-info_color.m-0 Selecciona a continuación tu EPS
                div.mt-4.mx-auto.Arrow.rounded-bd-complete.w-10.h-10.flex.items-center.justify-center.border-none.outline-none
                  span.material-icons.text-primary arrow_downward
              div(v-else)
                p.text-good_color.bg-good_background.p-2.py-0.Title.mx-auto.mt-2.uppercase.text-sm.font-normal
                  small.m-0: strong.m-0
                    | {{ eps.name }}
        transition-group(name="fadeIn" tag="div")
          home(v-if="trip === 'Home' || trip === 'Home_dates' || trip === 'Home_appointments'" key="Home")
          users-names(v-else-if="trip === 'UsersNames'" key="UsersNames")
          validation-data(v-else-if="trip === 'ValidationData'" key="ValidationData")
          id-component(v-else-if="trip === 'ID'" key="ID")
          form-documents(v-else-if="trip === 'FormDocuments' || trip === 'FormDocumentsDate'" key="FormDocuments")
          form-documents-add(v-else-if="trip === 'FormDocumentsAdd'" key="FormDocumentsAdd")
          form-documents-validation(v-else-if="trip === 'FormDocumentsValidation'" key="FormDocumentsValidation")
          form-documents-validation-info(
            v-else-if="trip === 'FormDocumentsValidationInfo'" key="FormDocumentsValidationInfo"
          )
          verification-data-date(
            v-else-if="trip === 'VerificationDataDate'" key="VerificationDataDate"
          )
          date-agended(v-else-if="trip === 'DateAgended'" key="DateAgended")
          manage-date(v-else-if="trip === 'ManageDate'" key="ManageDate")
          drugstore(v-else-if="trip === 'Drugstore'" key="Drugstore")
          p(v-else key="NotExist") No existe la vista
    modal-component(
      v-if="showModal"
      :closeModal="closeModal"
      :responseState="modalState.responseState"
      @close-button="getHandleCloseButton"
    ).text-center
      .px-5.m-0
        h2.text-primary.font-semibold.text-lg.mb-3 {{ modalState.responseToContinueTitle }}
        p.text-info_color.mb-3.lowercase.truncate.w-full.max-w-full {{ modalState.responseToContinue }}
        div(v-if="modalState.showProgress")
          progress-bar(size="medium" :val="valueProgress" style="width: 100%; height: 30px;" :text="`Enviando archivo ... ${valueProgress}%`" :text-fg-color="'white'")
        button-component(
          :text="modalState.buttonText"
          :onClick="handleCloseModalButton"
          themeSelected="secondary"
          v-if="!modalState.otherButtonCancel && !modalState.otherButtonCancelDelete && !modalState.iWantGoToHome"
        ).my-5.max-w-xs.text-center.mx-auto
        div(v-if="modalState.iWantGoToHome").flex
          button-component(
            :text="modalState.buttonText"
            :onClick="handleGoHomeModal"
            themeSelected="secondary"
          ).my-5.max-w-xs.text-center.mx-auto
        div(v-if="modalState.otherButtonCancel").flex
          button-component(
            text="No"
            :onClick="handleCloseModalButton"
            themeSelected="light"
          ).my-5.text-center.mx-auto.buttonMaxWidth
          button-component(
            text="Cancelar"
            :onClick="handleCancelDate"
            themeSelected="secondary"
          ).my-5.text-center.mx-auto.ml-5.buttonMaxWidth
        div(v-if="modalState.otherButtonCancelDelete").flex
          button-component(
            text="No"
            :onClick="handleCloseModalButton"
            themeSelected="light"
          ).my-5.text-center.mx-auto.buttonMaxWidth
          button-component(
            text="Eliminar"
            :onClick="handleDeleteEvery"
            themeSelected="secondary"
          ).my-5.text-center.mx-auto.ml-5.buttonMaxWidth
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import ProgressBar from "vue-simple-progress";
import loadingMessage from "../utils/loadingMessage";
var moment = require("moment");

export default {
  name: "root",
  data() {
    return {
      handleCloseButton: null,
      showFixed: true,
    };
  },
  components: {
    ProgressBar,
    // /* COMPONENTS /*
    HeaderComponent: () => import("../components/general/Header.vue"),
    ModalComponent: () => import("../components/Modal.vue"),
    ButtonComponent: () => import("../components/general/Button.vue"),
    // /* PAGES /*
    IdComponent: () => import("./ID.vue"),
    Home: () => import("./Home.vue"),
    UsersNames: () => import("./UsersNames.vue"),
    FormDocuments: () => import("./FormDocuments.vue"),
    FormDocumentsAdd: () => import("./FormDocumentsAdd.vue"),
    FormDocumentsValidation: () => import("./FormDocumentsValidation.vue"),
    FormDocumentsValidationInfo: () => import("./FormDocumentsValidationInfo.vue"),
    ValidationData: () => import("./ValidationData.vue"),
    Drugstore: () => import("./Drugstore.vue"),
    VerificationDataDate: () => import("./VerificationDataDate.vue"),
    DateAgended: () => import("./DateAgended.vue"),
    ManageDate: () => import("./ManageDate.vue"),
  },
  created() {
    this.changeFooterValue(this.trip);
  },
  // mounted() {
  //   const $main = document.querySelector("main.Main");
  //   $main.addEventListener("scroll", this.onScroll);
  // },
  watch: {
    trip(value) {
      if (value === "Home" && !this.drugstoresList.length) { //FIXME: Change to the future the values of trip Home for the dates and this
        this.clearValues({ onlyEps: true });
      }
      this.changeFooterValue(value);
    },
  },
  computed: {
    ...mapState({
      trip: (state) => state.root.trip,
      agendamientoMode: (state) => state.root.agendamientoMode,
      footerMode: (state) => state.root.footerMode,
      showModal: (state) => state.root.showModal,
      modalState: (state) => state.root.modalState,
      eps: (state) => state.eps.epsState,
      drugstoresList: (state) => state.drugstore.drugstoresList,
      responseAppointment: (state) => state.appointments.responseAppointment,
      error: (state) => state.appointments.error,
      env: (state) => state.environment.environment.env,
      manageDate: (state) => state.drugstore.manageDate,
      appointments: (state) => state.appointments.appointments,
      userData: (state) => state.root.userData,
      user: (state) => state.user.userData,
      valueProgress: (state) => state.root.valueProgress,
      schedule: (state) => state.appointments.schedule,
    }),
    smallFooter() {
      return this.trip === "FormDocuments" ? " content_sm " : "";
    },
    goBackParameter() {
      return (
        this.trip === "Home_dates" ? "ValidationData" :
        this.trip === "FormDocumentsDate" ? "Home_dates" : null
      );
    },
  },
  methods: {
    ...mapActions("eps", [
      "clearValues",
    ]),
    ...mapActions("root", [
      "goBack",
      "handleShowModal",
      "changeTrip"
    ]),
    ...mapMutations("root", [
      "setState",
    ]),
    ...mapActions([
      "updateAppointment",
      "fetchAppointments",
      "setProcessing",
      "postUsers"
    ]),
    handleGoBack() {
      this.goBack({
        goToRoute: (path) => {
          if (location.pathname !== path) {
            this.$router.push({ path });
          } else {
            this.$router.push({ path: "/login", });
          }
        },
        goBackParameter: this.goBackParameter,
      });
    },
    // onScroll() {
    //   const $main = document.querySelector("main.Main");
    //   const newShowFixed = $main.scrollTop < 160;
    //   this.showFixed = newShowFixed;
    // },
    handleGoHomeModal() {
      this.changeTrip("Home");
      this.handleCloseModalButton();
    },
    changeFooterValue(value) {
      switch (value) {
        case "ID":
          this.showFixed = false;
          this.setState({ key: "agendamientoMode", value: true });
          this.setState({ key: "footerMode", value: true });
        break;
        case "Home":
          if (this.trip !== "Home_dates" && this.trip !== "Home_appointments") {
            this.showFixed = true;
          }
          this.setState({ key: "agendamientoMode", value: true });
          this.setState({ key: "footerMode", value: false });
        break;
        case "ValidationData":
          this.showFixed = false;
          this.setState({ key: "agendamientoMode", value: true });
          this.setState({ key: "footerMode", value: true });
        break;
        case "FormDocuments":
          this.showFixed = false;
          this.setState({ key: "agendamientoMode", value: true });
          this.setState({ key: "footerMode", value: true });
        break;
        case "FormDocumentsAdd":
          this.showFixed = false;
          this.setState({ key: "agendamientoMode", value: true });
          this.setState({ key: "footerMode", value: true });
        break;
        case "FormDocumentsValidation":
          this.showFixed = false;
          this.setState({ key: "agendamientoMode", value: true });
          this.setState({ key: "footerMode", value: true });
        break;
        case "FormDocumentsValidationInfo":
          this.showFixed = false;
          this.setState({ key: "agendamientoMode", value: true });
          this.setState({ key: "footerMode", value: true });
        break;
        case "Drugstore":
          this.showFixed = false;
          this.setState({ key: "agendamientoMode", value: false });
          this.setState({ key: "footerMode", value: false });
        break;
        case "VerificationDataDate":
          this.showFixed = false;
          this.setState({ key: "agendamientoMode", value: true });
          this.setState({ key: "footerMode", value: true });
        break;
        case "DateAgended":
          this.showFixed = false;
          this.setState({ key: "agendamientoMode", value: false });
          this.setState({ key: "footerMode", value: false });
        break;
        case "ManageDate":
          this.showFixed = false;
          this.setState({ key: "agendamientoMode", value: true });
          this.setState({ key: "footerMode", value: true });
        break;
        case "UsersNames":
          this.showFixed = false;
          this.setState({ key: "agendamientoMode", value: false });
          this.setState({ key: "footerMode", value: true });
        break;
        default:
          this.showFixed = false;
          this.setState({ key: "agendamientoMode", value: true });
          this.setState({ key: "footerMode", value: false });
        break;
      }
    },
    closeModal() {
      this.handleShowModal({
        showModal: false,
        modalState: {},
      });
    },
    handleDeleteEvery() {
      this.modalState.onClickDelete();
      this.handleCloseModalButton();
    },
    handleCloseModalButton() {
      this.handleCloseButton();
    },
    getHandleCloseButton(handleCloseButton) {
      this.handleCloseButton = handleCloseButton;
      this.setState({ key: "closeModal", value: handleCloseButton });
    },
    
    async handleCancelDate() {
      
      try {
        this.handleShowModal(loadingMessage({
          title: "Cancelando tu cita...",
          state: "loading",
        }));

        let data = {
          branch: this.manageDate.branch,
          status: 'CANCELED',
          schedule: this.manageDate.schedule,
          code: this.manageDate.code,
          startAt: this.manageDate.startDate,
        };
        
        this.loading = true;
        await this.updateAppointment({
            url: this.env.VUE_APPOINTMENTS_DEBMEDIA_SERVER,
            headers: {
              'token_appointments': this.env.VUE_APPOINTMENTS_DEBMEDIA_API_KEY,
            },
            queryData: '',
            data: data
        });
        this.loading = false;
        if(this.responseAppointment.status == 'CANCELED'){

          this.postUsers({
            id: this.userData.id,
            name: this.userData.name,
            document: this.userData.documentNumber,
            documentType: this.userData.dcType,
            email: this.user.email,
            phone: this.user.phone,
            address: this.user.address
          });

          // Send data action
          this.setProcessing({
            document: this.userData.documentNumber,
            timestamp_click: moment().toDate().getTime(),
            appointment_code: this.manageDate.code,
            action: 'Cancelación'
          });

          // this.handleCloseModalButton();
          this.handleShowModal(loadingMessage({
            title: "Cita cancelada con éxito",
            state: "success",
          }));

          let queryData = '?customer.dni='+ this.userData.documentNumber + "&status=CONFIRMED";
          await this.fetchAppointments({
            url: this.env.VUE_APPOINTMENTS_DEBMEDIA_SERVER,
            headers: {
              'token_appointments': this.env.VUE_APPOINTMENTS_DEBMEDIA_API_KEY,
            },
            queryData: queryData
          });

          if(this.appointments.length > 0){
            this.changeTrip('Home_dates');
          } else this.changeTrip("ValidationData");

        }else{
          throw new Error(this.error)
        }

      } catch (error) {
        console.error("[error: Falla en el servicio]:", error);
        this.handleShowModal(loadingMessage({
          title: "Lo sentimos ha ocurrido un error al cancelar tu cita.",
          state: "danger",
        }));
      }
    },
  },
}
</script>

<style scoped>
.Title {
  max-width: 200px;
  width: fit-content;
}

.Main {
  /* height: calc(100vh - 155.433px); */
  overflow-y: auto;
  scroll-behavior: smooth;
}

.fadeIn-enter-active, .fadeIn-leave-active {
  will-change: opacity;
  transition-delay: 0.02s;
  transition: 0.7s all;
}

.fadeIn-enter, .fadeIn-leave-to /* .fadeIn-leave-active below version 2.1.8 */ {
  opacity: 0;
  visibility: hidden;
}

.buttonMaxWidth {
  max-width: 150px;
}

.HeaderDk {
  /* transition: 1s all !important; */
}

.showFixed {
  height: 100%;
  max-height: 71px;
  overflow: hidden;
  transition: 1s all !important;
}

.addMarginTop {
  /* height: calc(100vh - 160.433px) !important; */
  padding-top: 148.433px;
}

.addMarginTopSpecial {
  /* height: calc(100vh - 95px) !important; */
  padding-top: 80px;
}

/* @keyframes smallHeader {
  0% {
    transform: scaleY(1);
  }
  100% {
  }
} */
</style>